'use client';
import { useState, useEffect } from 'react';
import Footer from '../components/common/Footer';
import Header from '../components/common/Header';
import HeroSection from './HeroSection';
import WhatWeDoSection from './WhatWeDoSection';
import PricingSection from './PricingSection';
import ProcessSection from './ProcessSection';
import TargetAudienceSection from './TargetAudienceSection';
import WhyChooseUsSection from './WhyChooseUsSection';
import TimelineSection from './TimelineSection';
import FAQSection from './FAQSection';

interface ServiceCategory {
  id: number
  title: string
  services: string[]
}

interface PricingPlan {
  id: number
  name: string
  price: string
  description: string
  features: string[]
  isPopular?: boolean
}

export default function HomePage() {
  const [serviceCategories, setServiceCategories] = useState<ServiceCategory[]>([])
  const [pricingPlans, setPricingPlans] = useState<PricingPlan[]>([])
  const [loading, setLoading] = useState<boolean>(true)

  useEffect(() => {
    loadHomeData()
  }, [])

  const loadHomeData = async (): Promise<void> => {
    try {
      // Simulate API call with dummy data
      setTimeout(() => {
        setServiceCategories([
          {
            id: 1,
            title: 'Creative and Design',
            services: ['Social graphics', 'Ad creatives', 'Pitch decks', 'Landing pages', 'Thumbnails']
          },
          {
            id: 2,
            title: 'Video and Motion',
            services: ['Short form edits', 'Promo videos', 'Basic motion graphics', 'Repurposed clips']
          },
          {
            id: 3,
            title: 'Web and Funnel',
            services: ['Website updates', 'Landing pages', 'Lead capture flows', 'Basic funnels']
          }
        ])

        setPricingPlans([
          {
            id: 1,
            name: 'Sirloin Cut',
            price: '$1,600',
            description: 'For teams that need steady creative production',
            features: ['One active request', 'Predictable weekly output', 'Design, video, and web updates', 'Email support and async video feedback']
          },
          {
            id: 2,
            name: 'Ribeye Cut',
            price: '$2,800',
            description: 'For teams managing multiple priorities and campaigns',
            features: ['Two active requests', 'Parallel workstreams', 'Monthly strategy huddle', 'Priority support'],
            isPopular: true
          },
          {
            id: 3,
            name: 'Tomahawk Cut',
            price: '$3,900',
            description: 'For organizations wanting a full creative department without hiring one',
            features: ['Three active requests', 'Priority workflow', 'Monthly strategy and planning call', 'Support for internal and freelance teams']
          }
        ])
        
        setLoading(false)
      }, 1000)
    } catch (error) {
      console.error('Failed to load home data:', error)
      setLoading(false)
    }
  }

  return (
    <>
      <Header />
      <main className="min-h-screen">
        <HeroSection />
        <WhatWeDoSection 
          serviceCategories={serviceCategories}
          loading={loading}
        />
        <PricingSection 
          pricingPlans={pricingPlans}
          loading={loading}
        />
        <ProcessSection />
        <TargetAudienceSection />
        <WhyChooseUsSection />
        <TimelineSection />
        <FAQSection />
      </main>
      <Footer />
    </>
  )
}